"use client";

import { useEffect, useState } from "react";
import { CartDrawer, Footer } from "@/components";

type DeferredGlobalChromeProps = {
  base: string;
};

export default function DeferredGlobalChrome({ base }: DeferredGlobalChromeProps) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if ("requestIdleCallback" in window) {
      const idleId = window.requestIdleCallback(
        () => setReady(true),
        { timeout: 1200 }
      );
      return () => window.cancelIdleCallback(idleId);
    }
    const timerId = globalThis.setTimeout(() => setReady(true), 500);
    return () => globalThis.clearTimeout(timerId);
  }, []);

  if (!ready) return null;

  return (
    <>
      <Footer base={base} />
      <CartDrawer />
    </>
  );
}
